import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html"
})
export class FooterComponent implements OnInit {
	public leftMessage = "MetaAccess NAC";
	public rightMessage: string;
	constructor() {
		this.rightMessage = `&copy; ${new Date().getFullYear()} OPSWAT, Inc.`;
	}

	public ngOnInit() {
	}
}
